type Props = {
  size: number;
  color?: string;
};

const RoomWear = ({ size, color }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.8602 3.75732C18.2036 3.7914 18.5266 3.94329 18.7728 4.18945L23.5833 9L19.8333 12.75L18.3333 11.25V20.25H6.33331V11.25L4.83331 12.75L1.08331 9L5.89386 4.18945C6.17511 3.9082 6.55666 3.75006 6.95441 3.75H17.7122L17.8602 3.75732ZM15.3333 18.75H16.8333V15.75H15.3333V18.75ZM7.83331 18.75H13.8333V15.75H7.83331V18.75ZM3.20441 9L4.83331 10.6289L5.27277 10.1895C5.70176 9.76046 6.34702 9.63209 6.90753 9.86426C7.46793 10.0965 7.83331 10.6434 7.83331 11.25V14.25H13.6905L8.49469 5.25H6.95441L3.20441 9ZM13.15 10.314L15.4227 14.25H16.8333V11.25C16.8333 10.6434 17.1987 10.0965 17.7591 9.86426C18.3196 9.63209 18.9649 9.76046 19.3939 10.1895L19.8333 10.6289L21.4622 9L17.7122 5.25H16.0738L13.15 10.314ZM12.2835 8.81396L14.3416 5.25H10.2261L12.2835 8.81396Z"
        fill={color || '#212222'}
      />
    </svg>
  );
};

export default RoomWear;
